<template>
  <div class="sidebar-container">
    <div class="control-options flex space-between">
      <span class="blue-title" v-if="!viewingFilters"
        >Spray Sessions Displayed</span
      >
      <filter-button
        :onClick="toggleFilterView"
        v-if="!viewingFilters"
      ></filter-button>
      <rounded-button :onClick="applyFilterChanges" v-if="viewingFilters"
        >Apply Filter Updates</rounded-button
      >
      <x-button v-if="viewingFilters" :onClick="toggleFilterView" />
    </div>
    <div class="sidebar-content-container" tabindex="0">
      <div v-if="viewingFilters">
        <filter-view :settings="filterSettings"></filter-view>
      </div>
      <div v-else>
        <sidebar-list-item
          v-for="(adulticide, i) in adulticides"
          :adulticide="adulticide"
          :key="i"
        >
        </sidebar-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import RoundedButton from '../../common/rounded-button';
import SidebarListItem from './sidebar-list-item.vue';
import FilterButton from '../../map/sidebar/filter-button.vue';
import XButton from '../../map/sidebar/x-button.vue';
import FilterView from './filter-view.vue';
export default {
  components: {
    FilterButton,
    SidebarListItem,
    FilterView,
    RoundedButton,
    XButton,
  },

  props: {
    adulticides: Array,
    viewingFilters: Boolean,
  },

  computed: {
    filterSettings() {
      const {
        displayFilterSettings,
        filters: filtersSettings,
      } = this.$store.state.sprayPaths.settings;
      if (!displayFilterSettings) {
        return null;
      }
      const filtersSettingsKeys = Object.keys(filtersSettings);
      const reducer = (acc, key) => ({
        ...acc,
        [key]: {
          ...filtersSettings[key],
        },
      });
      const filtersSettingsCopy = filtersSettingsKeys.reduce(reducer, {});
      return filtersSettingsCopy;
    },
  },

  methods: {
    toggleFilterView() {
      this.$store.dispatch('setDisplayFilterSettings', !this.viewingFilters);
    },
    applyFilterChanges() {
      const { $store, filterSettings } = this;
      const { commit } = $store;
      this.toggleFilterView();
      commit('applySprayPathFilterSettings', filterSettings);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';
.sidebar-container {
  overflow: hidden;
  margin-right: -9px;
  width: 30.5rem;
  height: 800px;
  line-height: initial;

  & .control-options {
    display: flex;
    padding-left: 2rem;
    flex-direction: row;
    margin-bottom: 1rem;
    margin-right: 1rem;

    & .blue-title {
      margin-top: 0.625rem;
    }
  }

  & .sidebar-content-container {
    overflow: hidden;
    overflow-y: auto;
    height: 762px;
    outline: none;
  }
}
</style>
